/** @jsx jsx */
import { jsx } from "theme-ui"

const BackgroundGradient = () => {
  return (
    <div
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        zIndex: -2,
        background:
          "radial-gradient(ellipse at center, #fefefe 0%,#f0f4ff 100%)",
      }}
    />
  )
}

export default BackgroundGradient
